import React from "react";
import "./Services.css";
import Card from "../Card/Card";
import LogoLEA from "../../img/logo.png";

import { motion } from "framer-motion";
import Resume from './resume.pdf';

const Services = () => {


  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };



  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span className="tacm">ESISA ANALYTICA sur le toit de l'IA</span>
        <span className="tacm">services</span>
        <span className="tacm">
 <strong>LEA</strong>  se positionne au cœur de la technologie de <strong>l'IA</strong> , accompagnant les entreprises dans leur transformation numérique grâce à cette dernière. Nous œuvrons dans des domaines aussi variés que <strong>l'IoT</strong> , <strong>l'IA</strong> , la <strong>médecine numérique</strong> , et bien d'autres encore.
</span>

        <a className="tacm" href={Resume} download>
          <button className="button s-button">En savoir plus </button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
  {/* Unité de Recherche en Science des Données et Modélisation */}
  <motion.div
    initial={{ left: "25rem", top: "0rem" }}
    whileInView={{ left: "14rem", top: "0rem" }}
    transition={transition}
  >
    <Card
      image={LogoLEA}
      heading={"Unité de Recherche en Science des Données et Modélisation"}
      detail={
        "Développement de modèles prédictifs basés sur des approches bayésiennes, méthodes d'optimisation multi-objectifs, et analyse de données multi-dimensionnelles. Études approfondies sur les techniques de factorisation matricielle, modèles génératifs adversariaux pour la synthèse de données et algorithmes de réduction de dimensionnalité non linéaires (t-SNE, UMAP)."
      }
    />
  </motion.div>

  {/* Laboratoire d’Intelligence Artificielle et Exploration des Données */}
  <motion.div
    initial={{ left: "-7rem", top: "5rem" }}
    whileInView={{ left: "-7rem", top: "5rem" }}
    transition={transition}
  >
    <Card
      image={LogoLEA}
      heading={"Laboratoire d’Intelligence Artificielle et Exploration des Données"}
      detail={
        "Conception de nouveaux paradigmes d’apprentissage supervisé, semi-supervisé et auto-supervisé en exploitant des modèles de gradient boosting (XGBoost, LightGBM, CatBoost) et des architectures hybrides combinant réseaux neuronaux et méthodes symboliques. Implémentation d’algorithmes d’exploration de données massives via des techniques de clustering avancées (DBSCAN, Mean-Shift, Spectral Clustering)."
      }
    />
  </motion.div>

  {/* Centre de Recherche en Réseaux Neuronaux et Traitement du Langage */}
 
  {/* Laboratoire des Systèmes Intelligents et IoT */}
  <motion.div
    initial={{ left: "-25rem", top: "15rem" }}
    whileInView={{ left: "-25rem", top: "15rem" }}
    transition={transition}
  >
    <Card
      image={LogoLEA}
      heading={"Laboratoire des Systèmes Intelligents et IoT"}
      detail={
        "Développement de modèles d’apprentissage embarqués (TinyML) pour l’optimisation des systèmes IoT avec implémentation sur microcontrôleurs et architectures edge computing. Recherche sur la fusion de capteurs intelligents et l’apprentissage fédéré pour la confidentialité des données en environnements distribués. Déploiement de modèles d’intelligence ambiante en réseaux de capteurs hétérogènes (5G, LoRa, ZigBee)."
      }
    />
  </motion.div>

  {/* Centre d’Analyse en Temps Réel et Automatisation */}
  <motion.div
    initial={{ left: "-4rem", top: "23rem" }}
    whileInView={{ left: "-4rem", top: "23rem" }}
    transition={transition}
  >
    <Card
      image={LogoLEA}
      heading={"Centre d’Analyse en Temps Réel et Automatisation"}
      detail={
        "Optimisation des pipelines de traitement de données en temps réel via Apache Kafka, Flink et Spark Streaming. Développement de systèmes de détection d’anomalies en streaming avec apprentissage non supervisé (Isolation Forest, Autoencoders). Intégration de stratégies d’apprentissage par renforcement pour l’automatisation industrielle et la robotique autonome (PPO, DDPG, SAC)."
      }
    />
  </motion.div>

  {/* Pôle d’Excellence en Architectures IA et Extraction de Contexte */}
  <motion.div
    initial={{ left: "13rem", top: "20rem" }}
    whileInView={{ left: "13rem", top: "20rem" }}
    transition={transition}
  >
    <Card
      image={LogoLEA}
      heading={"Pôle d’Excellence en Architectures IA et Extraction de Contexte"}
      detail={
        "Développement de modèles d’apprentissage auto-adaptatifs basés sur l’architecture Transformer et la modulation des pondérations via l’attention multi-têtes. Conception de moteurs de recommandation contextuels utilisant des autoencodeurs variationnels et des techniques de reinforcement learning. Recherche avancée en neuro-symbolic AI pour l’intégration de la logique formelle aux réseaux neuronaux convolutifs pour une prise de décision interprétable et robuste."
      }
      color="rgba(252, 166, 31, 0.45)"
    />
  </motion.div>

  <div className="blur s-blur2" style={{ background: "var(--purple)" }}></div>
</div>




    </div>
  );
};

export default Services;
